/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {SecondsToMinutesPipe as ɵa} from './lib/pipe/seconds-to-minutes';